var e = "11.0.0+unknown";
//#endregion
export { e as REPORT_PACKAGE_VERSION };
